import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './SalesOrders.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_pick_on_new_license_plateService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { taskId?: number, packagedAmount?: number, packagedPackId?: number, sourceLicensePlateId?: number, targetLocationId?: number, targetLicensePlateLookupCode?: string, serialNumberIds?: number[] }): Promise<{ ExecutionTimeInMilliseconds?: number, LicensePlateId?: number, TargetShippingContainerId?: number, TaskId?: number }> 
  {
    let url = `${environment.backendUrl}api/SalesOrders/functions/pick_on_new_license_plate`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

